"{\"path\":{\"baseUrl\":\"\\/\",\"scriptPath\":null,\"pathPrefix\":\"en\\/\",\"currentPath\":\"productfinder\",\"currentPathIsAdmin\":false,\"isFront\":false,\"currentLanguage\":\"en\"},\"pluralDelimiter\":\"\\u0003\",\"suppressDeprecationErrors\":true,\"ajaxPageState\":{\"libraries\":\"admin_toolbar\\/toolbar.tree,admin_toolbar\\/toolbar.tree.hoverintent,admin_toolbar_search\\/search,admin_toolbar_tools\\/toolbar.icon,big_pipe\\/big_pipe,bootstrap\\/popover,bootstrap\\/tooltip,colorbox\\/colorbox,colorbox\\/default,contextual\\/drupal.contextual-links,contextual\\/drupal.contextual-toolbar,core\\/drupal.active-link,google_analytics\\/google_analytics,quickedit\\/quickedit,regofix_cart\\/cart,regofix_domain_selector\\/domain_selector,regofix_product_comparison\\/comparison,regofix_product_comparison\\/comparison_update,regofix_productfinder\\/react_product_finder,regofix_sass\\/custom-datatables,regofix_sass\\/custom-scripts,regofix_sass\\/datatables,regofix_sass\\/dots,regofix_sass\\/equal,regofix_sass\\/font-awesome,regofix_sass\\/form-validation,regofix_sass\\/global-styling,regofix_sass\\/hammer-js,regofix_sass\\/lity,regofix_sass\\/moment,regofix_sass\\/yadcf,rf_overlay\\/overlay,system\\/base,tmgmt\\/drupal.tmgmt.toolbar,toolbar\\/toolbar,toolbar\\/toolbar.escapeAdmin,toolbar_menu\\/icons,tour\\/tour,user\\/drupal.user.icons,video_embed_field\\/responsive-video,views\\/views.ajax,views\\/views.module,webform_bootstrap\\/webform_bootstrap\",\"theme\":\"regofix_sass\",\"theme_token\":null},\"ajaxTrustedUrl\":{\"\\/en\\/search\\/results\":true},\"bigPipePlaceholderIds\":{\"callback=Drupal%5Cblock%5CBlockViewBuilder%3A%3AlazyBuilder\\u0026args%5B0%5D=masquerade\\u0026args%5B1%5D=full\\u0026args%5B2%5D\\u0026token=RkJIuNbq-EDtAN0PGvQq7FaKSYN6TfgvNMAthVadBSQ\":true,\"callback=Drupal%5CCore%5CRender%5CElement%5CStatusMessages%3A%3ArenderMessages\\u0026args%5B0%5D\\u0026token=_HAdUpwWmet0TOTe2PSiJuMntExoshbm1kh2wQzzzAA\":true,\"callback=user.toolbar_link_builder%3ArenderToolbarLinks\\u0026\\u0026token=xssKdKFVFD7N0FUPPcC1C7LrqMHpQFVzUhrI4cOeEgs\":true,\"callback=user.toolbar_link_builder%3ArenderDisplayName\\u0026\\u0026token=-MH2NzEnTzbzMk0ZGfGgoiw7G3j_-Q1ILWBRVhIOKLI\":true},\"google_analytics\":{\"trackOutbound\":true,\"trackMailto\":true,\"trackDownload\":true,\"trackDownloadExtensions\":\"7z|aac|arc|arj|asf|asx|avi|bin|csv|doc(x|m)?|dot(x|m)?|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt(x|m)?|pot(x|m)?|pps(x|m)?|ppam|sld(x|m)?|thmx|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd|xls(x|m|b)?|xlt(x|m)|xlam|xml|z|zip\",\"trackColorbox\":true,\"trackDomainMode\":2,\"trackCrossDomains\":[\"za.rego-fix.com\",\"ar.rego-fix.com\",\"br.rego-fix.com\",\"ca.rego-fix.com\",\"cl.rego-fix.com\",\"mx.rego-fix.com\",\"us.rego-fix.com\",\"cn.rego-fix.com\",\"in.rego-fix.com\",\"id.rego-fix.com\",\"il.rego-fix.com\",\"jp.rego-fix.com\",\"kr.rego-fix.com\",\"my.rego-fix.com\",\"ph.rego-fix.com\",\"sg.rego-fix.com\",\"tw.rego-fix.com\",\"th.rego-fix.com\",\"tr.rego-fix.com\",\"ad.rego-fix.com\",\"at.rego-fix.com\",\"be.rego-fix.com\",\"bg.rego-fix.com\",\"cz.rego-fix.com\",\"dk.rego-fix.com\",\"ee.rego-fix.com\",\"fi.rego-fix.com\",\"fr.rego-fix.com\",\"de.rego-fix.com\",\"hu.rego-fix.com\",\"ie.rego-fix.com\",\"it.rego-fix.com\",\"lv.rego-fix.com\",\"nl.rego-fix.com\",\"no.rego-fix.com\",\"pl.rego-fix.com\",\"pt.rego-fix.com\",\"ro.rego-fix.com\",\"ru.rego-fix.com\",\"sk.rego-fix.com\",\"si.rego-fix.com\",\"es.rego-fix.com\",\"ch.rego-fix.com\",\"uk.rego-fix.com\",\"au.rego-fix.com\",\"nz.rego-fix.com\"]},\"quickedit\":{\"csrf_token\":\"ybkDbJbjiThAEkA1jg6C8NtPERwsRPp-CC2RQyQ4kL8\"},\"regofix_cart\":null,\"comparison\":null,\"bootstrap\":{\"forms_has_error_value_toggle\":1,\"modal_animation\":1,\"modal_backdrop\":\"true\",\"modal_focus_input\":1,\"modal_keyboard\":1,\"modal_select_text\":1,\"modal_show\":1,\"modal_size\":\"\",\"popover_enabled\":1,\"popover_animation\":1,\"popover_auto_close\":1,\"popover_container\":\"body\",\"popover_content\":\"\",\"popover_delay\":\"0\",\"popover_html\":0,\"popover_placement\":\"right\",\"popover_selector\":\"\",\"popover_title\":\"\",\"popover_trigger\":\"click\",\"tooltip_enabled\":1,\"tooltip_animation\":1,\"tooltip_container\":\"body\",\"tooltip_delay\":\"0\",\"tooltip_html\":0,\"tooltip_placement\":\"auto left\",\"tooltip_selector\":\"\",\"tooltip_trigger\":\"hover\"},\"colorbox\":{\"transition\":\"elastic\",\"speed\":350,\"opacity\":0.4,\"slideshow\":false,\"slideshowAuto\":true,\"slideshowSpeed\":2500,\"slideshowStart\":\"start slideshow\",\"slideshowStop\":\"stop slideshow\",\"current\":\"{current} of {total}\",\"previous\":\"\",\"next\":\"\",\"close\":\"Close\",\"overlayClose\":true,\"returnFocus\":false,\"maxWidth\":\"98%\",\"maxHeight\":\"98%\",\"initialWidth\":\"300\",\"initialHeight\":\"250\",\"fixed\":true,\"scrolling\":true,\"mobiledetect\":false,\"mobiledevicewidth\":\"480px\"},\"regofix_tooltips\":{\"form_name\":\"Form variant of spindle interface\",\"interface_size\":\"Size of spindle interface\",\"nominal_size\":\"Suitable spindle interface\",\"norm_size\":\"test\",\"length_style\":\"Tool holder length\",\"o_mm\":\"Nominal tool shank diameter\",\"o_mm_clamping_nut\":\"Outside diameter clamping nut\",\"o_inch\":\"Nominal tool shank diameter\",\"bore_diameter_mm\":\"Bore diameter\",\"bore_diameter_decimal_inch\":\"Bore diameter\",\"field_bore_o_inch_\":\"Bore diameter\",\"field_bore_o_mm_\":\"Bore diameter\",\"b_height_mm\":\"Height of clamping nut\",\"c_thread\":\"Size of clamping nut thread\",\"image_tooltip\":\"Learn more about\",\"product_title\":\"See all details about this product\",\"whishlist_tooltip\":\"Did you know? You can add products to your wish list and get a quote today by REGO-FIX without creating a Login. Start now.\"},\"views\":{\"ajax_path\":\"\\/en\\/views\\/ajax\",\"ajaxViews\":{\"views_dom_id:478194f3b56cc200be33b117cf05c1bf278fddd8c654f182024e8a2b4c1585e5\":{\"view_name\":\"download_area\",\"view_display_id\":\"block_6_videos\",\"view_args\":\"\",\"view_path\":\"\\/productfinder\",\"view_base_path\":\"admin\\/manage-content\\/file-manager\",\"view_dom_id\":\"478194f3b56cc200be33b117cf05c1bf278fddd8c654f182024e8a2b4c1585e5\",\"pager_element\":0}}},\"domain_selector\":{\"AD\":{\"name\":\"Andorra\",\"languages\":{\"English\":\"https:\\/\\/ad.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/ad.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/ad.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/ad.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/ad.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/ad.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/ad.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/ad.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/ad.rego-fix.com\\/en?country-detected=true\"},\"AR\":{\"name\":\"Argentina\",\"languages\":{\"English\":\"https:\\/\\/ar.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/ar.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/ar.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/ar.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/ar.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/ar.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/ar.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/ar.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/ar.rego-fix.com\\/en?country-detected=true\"},\"AT\":{\"name\":\"Austria\",\"languages\":{\"English\":\"https:\\/\\/at.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/at.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/at.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/at.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/at.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/at.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/at.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/at.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/at.rego-fix.com\\/en?country-detected=true\"},\"AU\":{\"name\":\"Australia\",\"languages\":{\"English\":\"https:\\/\\/au.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/au.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/au.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/au.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/au.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/au.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/au.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/au.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/au.rego-fix.com\\/en?country-detected=true\"},\"BA\":{\"name\":\"Bosnia \\u0026 Herzegovina\",\"languages\":{\"English\":\"https:\\/\\/ba.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/ba.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/ba.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/ba.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/ba.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/ba.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/ba.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/ba.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/ba.rego-fix.com\\/en?country-detected=true\"},\"BE\":{\"name\":\"Belgium\",\"languages\":{\"English\":\"https:\\/\\/be.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/be.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/be.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/be.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/be.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/be.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/be.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/be.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/be.rego-fix.com\\/en?country-detected=true\"},\"BG\":{\"name\":\"Bulgaria\",\"languages\":{\"English\":\"https:\\/\\/bg.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/bg.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/bg.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/bg.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/bg.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/bg.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/bg.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/bg.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/bg.rego-fix.com\\/en?country-detected=true\"},\"BR\":{\"name\":\"Brazil\",\"languages\":{\"English\":\"https:\\/\\/br.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/br.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/br.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/br.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/br.rego-fix.com\\/pt-br\",\"Espa\\u00f1ol\":\"https:\\/\\/br.rego-fix.com\\/es\",\"Italiano\":\"https:\\/\\/br.rego-fix.com\\/it\",\"\\u65e5\\u672c\\u8a9e\":\"https:\\/\\/br.rego-fix.com\\/ja\"},\"domain\":\"https:\\/\\/br.rego-fix.com\\/en?country-detected=true\"},\"CA\":{\"name\":\"Canada\",\"languages\":{\"English\":\"https:\\/\\/ca.rego-fix.com\\/en\",\"Deutsch\":\"https:\\/\\/ca.rego-fix.com\\/de\",\"\\u7b80\\u4f53\\u4e2d\\u6587\":\"https:\\/\\/ca.rego-fix.com\\/zh-hans\",\"Fran\\u00e7ais\":\"https:\\/\\/ca.rego-fix.com\\/fr\",\"Portugu\\u00eas\":\"https:\\/\\/ca.rego-fix.com\\/pt-br\"…"

/*global jQuery*/
/*eslint no-undef: "error"*/

import React, {Component} from 'react';
import extend from 'lodash/extend';
import has from 'lodash/has';
import PropTypes from 'prop-types';
import CustomSearchBox from './CustomSearchBox.js';
import ViewSwitcherHitsHeader from './ViewSwitcherHitsHeader.js';
import SortingArrowSelector from './SortingArrowSelector.js';
import CustomRefinementListFilter from './CustomRefinementListFilter.js';
import PageSizeSelect from './PageSizeSelect.js';
import ReactTooltip from 'react-tooltip'

import CustomSelect from './CustomSelect.js'
import { injectGlobal } from 'styled-components';
import {
  ActionBar,
  ActionBarRow,
  GroupedSelectedFilters,
  HitsStats,
  Layout,
  LayoutBody,
  LayoutResults,
  NoHits,
  Pagination,
  Panel,
  ResetFilters,
  SearchkitManager,
  SearchkitProvider,
  SideBar,
  SortingSelector,
  PageSizeSelector,
  TermQuery,
  Toggle,
  ViewSwitcherHits,
} from 'searchkit'
import './scss/style.css'
import './css/font-awesome.css'
import {columnConfigs, sortingOptions, getColumnConfig} from "./column-configs";

/* eslint no-unused-expressions: 0 */
injectGlobal`
  @font-face {
    font-family: 'FiraSansM';
    src: url('./fonts/FiraSans-Medium.otf')) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'FiraSansR';
    src: url('./fonts/FiraSans-Regular.otf')) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
`;

let host = 'https://regofix.ddev.site/en';

if (window.Drupal) {
  host = window.location.origin + "/" + window.drupalSettings.path.currentLanguage;
}

// If you want to open localhost via npm change this url
const envPublicUrl = "/modules/custom/regofix_productfinder/searchkit-starter-app/build";
const searchkit = new SearchkitManager(host, {
  searchUrlPath: "/elastic/post",
  timeout: 0
});

searchkit.translateFunction = (key) => {
  let translations = {
    'reset.clear_all': window.Drupal.t("Clear all filters"),
    'collets': window.Drupal.t("Collets"),
    'toolholders': window.Drupal.t("Toolholders"),
    'accessories': window.Drupal.t("Accessories"),
    'clamping_nuts_and_disks': window.Drupal.t("Clamping Nut"),
    'measuring_technology': window.Drupal.t("Measuring technology"),
  };

  // Use custom translation by key if exists.
  if (translations[key]) {
    return translations[key];
  }

  // Get Drupal translation.
  const drupalTranslation = window.Drupal.t(key);

  // Return Drupal translation if translated or use undefined for global default.
  return drupalTranslation === key ? undefined : drupalTranslation;
}

searchkit.addDefaultQuery((query) => {
  // Add domain access filters.
  const hostName = searchkit.options.getLocation().hostname.split(".");
  if (hostName[0].length != 2) {
    const domain = hostName[0].split('---');
    if (domain.length == 2 && domain[0].length == 2) {
      hostName[0] = domain[0];
    }
    else {
      return query;
    }
  }
  const subdomain = hostName[0] + "_regofix_tk";
  return query.addFilter('domain_access', TermQuery("domain_access", subdomain));
});

const SystemOption = (props) => {
  const resultsState = searchkit.accessors.statefulAccessors.system_name.resultsState;

  this.SystemEventListner = (e, props) => {
    resultsState.value = [];
    props.onClick()
  };


  let selectedSystem = '';
  if (resultsState.value !== null && resultsState.value.length !== 0) {
    if (props.itemKey !== resultsState.value[0]) {
      selectedSystem = ' disabled';
    }
    if (props.itemKey == resultsState.value[0]) {
      selectedSystem = ' is-active';
    }
  }
  return (
    <div
      className={props.bemBlocks.option().state({selected: props.selected}).mix(props.bemBlocks.container("item")) + selectedSystem}
      onClick={(e) => this.SystemEventListner(e, props)}>
      <input type="radio" className={props.bemBlocks.option("checkbox")} checked={props.active} readOnly={true}/>
      <div className={props.bemBlocks.option("text") + ' ' + props.label.replace(/\s/g, "-").toLowerCase()}>
        {window.Drupal.t(props.label)}
      </div>
      <div className={props.bemBlocks.option("count")}>{props.count}</div>
    </div>
  )
};

const ProductTypeOption = (props) => {
  const resultsState = searchkit.accessors.statefulAccessors.product_type.resultsState;
  this.ProductEventListner = (e, props) => {
    resultsState.value = [];
    props.onClick()
  };
  let selectedSystem = '';
  if (resultsState.value !== null && resultsState.value.length !== 0) {
    if (props.itemKey !== resultsState.value[0]) {
      selectedSystem = ' disabled';
    }
    if (props.itemKey == resultsState.value[0]) {
      selectedSystem = ' is-active';
    }
  }
  return (
    <div
      className={props.bemBlocks.option().state({selected: props.selected}).mix(props.bemBlocks.container("item")) + selectedSystem}
      onClick={(e) => this.ProductEventListner(e, props)}>
      <input type="radio" className={props.bemBlocks.option("checkbox")} checked={props.active} readOnly={true}/>
      <div className={props.bemBlocks.option("text")}>
        {window.Drupal.t(getProductTypeName(props.label))}
      </div>
      <div className={props.bemBlocks.option("count")}>{props.count}</div>
    </div>
  )
};

const getProductTypeName = (props) => {
  return Object.prototype.toString.call(props) === '[object Array]' ? props[0] : props
};

class ProductsListItem extends Component {

  attachQeuery() {
    const hostName = searchkit.options.getLocation().hostname;
    if (!hostName.includes('localhost')) {
      if (window.Drupal.ajax.bindAjaxLinks) {
        window.Drupal.ajax.bindAjaxLinks(document.body);
      }
      // attach openModal() for each links with '#overlay' in href
      window.scrollPos = window.pageYOffset;
      checkLinks();

      if (this.processed) {
        return;
      }
      this.processed = true;

      // load overlay data and open modal window
      function openModal(ev) {
        var scrollPos = window.pageYOffset;
        var current_lang = window.drupalSettings.path.currentLanguage;
        if (ev) {
          //debugger
          if (ev.event !== null) {
            ev.preventDefault();
            ev.stopPropagation();
            window.scrollTo(0, scrollPos);
          }
          window.Drupal.ajax({
            url: '/' + current_lang + '/overlay/' + ev.data.url
          }).execute();
        }

      }

      function checkLinks() {
        var links = jQuery('a').once('rf_overlay');
        jQuery.each(links, function (index, link) {
          var marker_pos = link.href.indexOf('#overlay=product-details');
          if (marker_pos > -1) {
            var modalLink = link.href.substr(marker_pos + 9);
            jQuery(link).removeClass("overlay-active").bind("click", {event: event, url: modalLink}, openModal);
          }
        });
      }

      // open overlay by url
      if (window.location.hash.indexOf('#overlay') >= 0) {
        var event = {event: null, data: {}};
        event.data.url = window.location.hash.substr(9);
        openModal(event);
      }

      if (jQuery(window).width() <= 960) {
        // Move search bar into header.
        var search_bar = '.sk-results-list__action-bar.sk-action-bar .sk-action-bar-row.search-bar';
        var header_filters = '.sk-layout__body .sk-action-bar-row.filters-header';
        jQuery(search_bar).detach().once().insertBefore(header_filters);

        // Hide/Show PF filters button.
        var $hide_button = jQuery('.sk-hide-filters');
        var default_text = window.Drupal.t('Hide filters');
        $hide_button.once().click(function () {
          jQuery('.sk-layout__filters .all-filters').toggle(function () {
              var button_text = ($hide_button.text() === default_text) ? window.Drupal.t('Show filters') : default_text;
              $hide_button.text(button_text);
            },
          );
        });
      }
    }
  }

  componentDidMount() {
    this.attachQeuery();
  }

  componentDidUpdate() {
    this.attachQeuery();
  }

  render() {
    const {bemBlocks, result} = this.props;
    let system = searchkit.state.system_name.length > 0 ? searchkit.state.system_name[0] : window.Drupal.t('ER');
    const systemClass = system.replace(/\s/g, "-").toLowerCase() + ' hits-border';
    const noResultsImage = envPublicUrl + "/images/age-no-image-220x220.png";
    const imageSrc = () => {
      if (result._source.hasOwnProperty('product_image')) {
        return result._source['product_image'];
      }
      switch (system) {
        case 'ER':
          return result._source.hasOwnProperty('er_image_url') ? result._source['er_image_url'] : noResultsImage;
        case 'powRgrip':
          return result._source.hasOwnProperty('pg_image_url') ? result._source['pg_image_url'] : noResultsImage;
        case 'micRun':
          return result._source.hasOwnProperty('mr_image_url') ? result._source['mr_image_url'] : noResultsImage;
        case 'uniTec':
          return result._source.hasOwnProperty('ml_image_url') ? result._source['ml_image_url'] : noResultsImage;
        case 'Measuring':
          return result._source.hasOwnProperty('ms_image_url') ? result._source['ms_image_url'] : noResultsImage;
        default:
          return noResultsImage
      }
    };
    system = window.Drupal.t(system);
    let url = "#overlay=product-details/";
    let langcode = has(window, 'drupalSettings.path.currentLanguage') ? window.drupalSettings.path.currentLanguage : "en";
    const hostName = searchkit.options.getLocation().hostname;
    const source = extend({}, result._source, result.highlight);
    let imageTooltip, titleTooltip, wishListTooltip;
    if (!hostName.includes('localhost')) {
      imageTooltip = window.drupalSettings.regofix_tooltips.image_tooltip+ " " + result._source.product_group_name;
      titleTooltip = window.drupalSettings.regofix_tooltips.product_title;
      wishListTooltip = window.drupalSettings.regofix_tooltips.whishlist_tooltip;
    }
    else {
      imageTooltip = window.Drupal.t("Learn more about") + ' ' + result._source.product_group_name;
      titleTooltip = window.Drupal.t("See all details about this product");
      wishListTooltip = window.Drupal.t("Did you know? You can add products to your wish list and get a quote today by REGO-FIX without creating a Login. Start now.");
    }

    let thisFirst = 0;
    if(/<\/?[a-z][\s\S]*>/i.test(source.title_ngram)) {
      let titleNgram = source.title_ngram[0];
      let titleNgramArr = titleNgram.split(" ");

      titleNgramArr.map((elem, index) => {
        if(/<\/?[a-z][\s\S]*>/i.test(elem)) {
          let parsed = new DOMParser().parseFromString(elem, "text/html");
          parsed = parsed.getElementsByTagName('em');
            for(let i = 0; i < parsed.length; i++) {
              if(parsed[i].outerText.length == 1) {
                let tegPos = titleNgramArr[index].search(parsed[i].outerHTML);
                let prefix = titleNgramArr[index].slice(0, tegPos);
                let toCat = titleNgramArr[index].slice(tegPos, tegPos+parsed[i].outerHTML.length);
                let postfix = titleNgramArr[index].slice(tegPos+parsed[i].outerHTML.length);

                if(!searchkit.state.q.split(" ").includes(parsed[i].outerText)) {
                  toCat = toCat.replace(/<[^>]*>?/gm, "");
                } else if (prefix.length > 0) {
                  toCat = toCat.replace(/<[^>]*>?/gm, "");
                }
                titleNgramArr[index] = prefix + toCat + postfix;
              }
              thisFirst++;
            }
          }
      });
      if(thisFirst > 1) {
        source.title_ngram = titleNgramArr.join(' ');
      }
    }
    let weblinks = [];

    const productType = searchkit.state.product_type && searchkit.state.product_type[0] != null ? searchkit.state.product_type[0] : 'default';

    return (
      <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
        <div className={systemClass}></div>
        <div className="product-name">

          <div className={bemBlocks.item("image")} data-tip={imageTooltip} data-for='rfTooltip'>
            <a href={"/en" + result._source.product_group_path + "?system=" + searchkit.state.system_name} target="_blank"><img alt="Product" data-qa="image" src={imageSrc()}/></a>
          </div>
          <div className={bemBlocks.item("details")}>
            <a href={url + source.nid} data-tip={titleTooltip} data-for={'rfTooltip'}><h2 className={bemBlocks.item("title")}
                                                                                          // dangerouslySetInnerHTML={{__html: source.title_ngram}}></h2>
              dangerouslySetInnerHTML={{__html: !/<\/?[a-z][\s\S]*>/i.test(source.title_ngram) ? source.title : source.title_ngram}}></h2>

            </a>
            <span className={bemBlocks.item("label")}>{ window.Drupal.t("SKU") + " " }</span>
            <span className={bemBlocks.item("text")}  dangerouslySetInnerHTML={{__html: !/<\/?[a-z][\s\S]*>/i.test(source.field_sku_ngram)  ? source.field_sku_fulltext : source.field_sku_ngram}}></span>
          </div>
        </div>

        <div className={bemBlocks.item("type")}>
            {/*{window.Drupal.t(searchkit.state.system_name[0]) + " "}<br/>*/}
            {/*{searchkit.translateFunction(getProductTypeName(source.type))}*/}
            {
              (() => {
                if (source.weblink_url) {
                  let weblinks = [];
                  source.weblink_url.forEach((link, index) => {
                    weblinks.push(<a key={index} className={bemBlocks.item("link")} title={source.weblink_title[index]} target="_blank" href={link}>{source.weblink_title[index] || window.Drupal.t("Link")}</a>)
                  })
                  return weblinks;
                } else {
                  return <div className={bemBlocks.item("text")}>{"-"}</div>
                }
              })()
            }
        </div>

        <div className={bemBlocks.item("field-technical-draws")}>
          {(() => {
            if (source.field_technical_drawings_url) {
              let technical_drawings = [];
              source.field_technical_drawings_url.forEach((element, index) => {
                technical_drawings.push(<a key={index} className={bemBlocks.item("link")} title={source.field_technical_drawings_filename[index]} target="_blank" href={element}>{source.field_technical_drawings_description[index] || window.Drupal.t("Download")}</a>);
              })
              return technical_drawings
            }
            else {
              return <div className={bemBlocks.item("text")}>{"-"}</div>
            }
          })()}
        </div>
        {getColumnConfig(productType).map((column, index) => {
          return (
            <div className={bemBlocks.item("field-interface-size-name")}>
              <p className="size-mobile-show">{column.text}:</p>
              <div className={bemBlocks.item("text")}>{source[column.field] || "-"}</div>
            </div>
          );
        })}
        <div className={bemBlocks.item("add-to-basket")}>
          <a className={bemBlocks.item("link") + " use-ajax"} data-tip={wishListTooltip} data-for={'rfTooltip'}
             href={"/product/cart/nojs/" + source.nid + "/add"}>{window.Drupal.t("Add to wish list")}</a>
        </div>
        <ReactTooltip place="top" id='rfTooltip' effect='solid' getContent={(dataTip) => `${dataTip}`} delayShow={300}/>
      </div>

    )
  }
}

class App extends Component {


  constructor() {
    super();

    if (!window.Drupal) {
      window.Drupal = {
        t: (str) => { return str; }
      };
    }
    this.state = {
      cols: [
        <ViewSwitcherHitsHeader customClasses={"interface-size"} customText={window.Drupal.t("Interface Size")}/>,
        <ViewSwitcherHitsHeader customClasses={"norm-size"} customText={window.Drupal.t("Norm Size")}/>
      ],
      currentProductType: null,
    };
  }

  componentDidMount() {
    searchkit.emitter.addListener(this.updateCols);
  }

  updateCols = () => {
    const productType = searchkit.state.product_type ? searchkit.state.product_type[0] : 'default';

    const newCols = (columnConfigs[productType] || columnConfigs.default).map(config => (
      <ViewSwitcherHitsHeader
        key={config.key}
        customClasses={config.key}
        customText={window.Drupal.t(config.text)}
      />
    ));
    this.setState({ cols: newCols });
  }

  render() {
    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout>
          <LayoutBody>
            <SideBar>
              <ActionBarRow className={'filters-header'}>
                <ViewSwitcherHitsHeader customClasses={"product-filters"} customText={window.Drupal.t("Filters")}/>
                <ResetFilters/>
                <div className="sk-hide-filters">{window.Drupal.t("Hide filters")}</div>
              </ActionBarRow>
              <div className="all-filters">
                <CustomRefinementListFilter id="system_name" title={window.Drupal.t("System Name")} field="system_name" operator="OR"
                                            itemComponent={SystemOption} size={10} collapsable={true}/>
                <CustomRefinementListFilter id="product_type" title={window.Drupal.t("Product Type")} field="type" operator="OR"
                                            itemComponent={ProductTypeOption} size={10} collapsable={true}/>
                <CustomRefinementListFilter id="product_category_name" title={window.Drupal.t("Product Category")}
                                            field="product_category_name" operator="OR" size={10} collapsable={true}/>
                <CustomRefinementListFilter id="product_group_name" title={window.Drupal.t("Product Group")} field="product_group_name"
                                            operator="OR" size={10} collapsable={true}/>
                <Panel className={'filters-expert'} title={window.Drupal.t("Expert Filters")} collapsable={true} defaultCollapsed={false}>
                  <CustomRefinementListFilter id="form_name" title={window.Drupal.t("Form Name")} field="form_name" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="field_interface_size_name" title={window.Drupal.t("Interface Size")}
                                              field="field_interface_size_name" operator="OR" listComponent={CustomSelect}
                                              size={50} select={true}/>
                  <CustomRefinementListFilter id="norm_size" title={window.Drupal.t("Norm Size")} field="norm_size" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="lenght_style" title={window.Drupal.t("Length Style")} field="lenght_style" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="o_mm" title={window.Drupal.t("Ø [mm]")} field="o_mm" operator="OR"
                                              listComponent={CustomSelect}
                                              size={100} select={true}/>
                  <CustomRefinementListFilter id="o_inch" title={window.Drupal.t("Ø [Inch]")} field="o_inch" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="field_bore_o_inch_" title={window.Drupal.t("Ø [inch]")} field="field_bore_o_inch_"
                                              operator="AND" listComponent={CustomSelect} size={50} select={true} showMore={false}/>
                  <CustomRefinementListFilter id="field_bore_o_mm_" title={window.Drupal.t("Ø [mm]")}
                                              field="field_bore_o_mm_" operator="AND"
                                              listComponent={CustomSelect}
                                              size={50} select={true} showMore={false}/>
                  <CustomRefinementListFilter id="b_height_mm" title={window.Drupal.t("B height [mm]")} field="b_height_mm" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="c_thread" title={window.Drupal.t("C [thread]")} field="c_thread" operator="OR"
                                              listComponent={CustomSelect} size={50} select={true}/>
                  <CustomRefinementListFilter id="field_nominal_size" title={window.Drupal.t("Interface Size")} field="field_nominal_size"
                                              operator="OR" listComponent={CustomSelect} size={50} select={true}/>
                </Panel>
              </div>
            </SideBar>
            <LayoutResults>
              <ActionBar>
                <ActionBarRow className={'search-bar'}>
                  <CustomSearchBox autofocus={true} searchOnChange={true}
                             placeholder={window.Drupal.t("Search by Name or by SKU")}
                             queryFields={["title", "title_ngram", "field_sku_ngram", "field_sku_fulltext"]}
                             queryOptions={{"analyzer": "autocomplete", "default_operator": "and"}}
                  />
                </ActionBarRow>
                <ActionBarRow className={'selected-filters'}>
                  <GroupedSelectedFilters/>
                  <ResetFilters/>
                </ActionBarRow>
                <ActionBarRow className={'results-header'}>
                  <SortingSelector options={sortingOptions()} listComponent={Toggle}/>
                  <HitsStats translations={{
                    "hitstats.results_found": "{hitCount} " + window.Drupal.t("products found")
                  }}/>
                  <ViewSwitcherHitsHeader customClasses={"product-type"} customText={window.Drupal.t("Product Data")}/>
                  <ViewSwitcherHitsHeader customClasses={"technical-drawings"} customText={window.Drupal.t("Technical Drawings")}/>
                  { this.state.cols }
                  <ViewSwitcherHitsHeader customClasses={"wish-list"} customText={window.Drupal.t("Add to Wish List")}/>
                </ActionBarRow>
              </ActionBar>
              <ViewSwitcherHits
                hitsPerPage={15} highlightFields={["title", "title_ngram", "field_sku_ngram", "field_sku_fulltext"]}
                sourceFilter={[
                  "type",
                  "title",
                  "title_ngram",
                  "field_system",
                  "field_norm_size_name",
                  "field_interface_size_name",
                  "mr_image_url",
                  "er_image_url",
                  "pg_image_url",
                  "ml_image_url",
                  "ms_image_url",
                  "nid",
                  "file_dimension_sheet_dxf",
                  "file_dimension_sheet_pdf",
                  "field_3d_model_step",
                  "product_category_name",
                  "product_group_name",
                  "form_name",
                  "interface_size",
                  "norm_size",
                  "lenght_style",
                  "o_mm",
                  "o_inch",
                  "l_mm",
                  "lpr_mm",
                  "bore_diameter_mm",
                  "bore_diameter_decimal_inch",
                  "field_bore_o_inch_",
                  "field_bore_o_mm_",
                  "b_height_mm",
                  "c_thread",
                  "field_nominal_size",
                  "domain_access",
                  "status",
                  "field_sku_ngram",
                  "field_sku_fulltext",
                  "product_group_path",
                  "field_technical_drawings",
                  "field_technical_drawings_description",
                  "field_technical_drawings_url",
                  "field_technical_drawings_filename",
                  "product_image",
                  "weblink_url",
                  "weblink_title",
                ]}
                hitComponents={[
                  {key: "list", title: "List", itemComponent: ProductsListItem}
                ]}
                scrollTo=".sk-layout"
              />
              <NoHits suggestionsField="title"/>
              <div className="footer">
                <Pagination pageScope={3} showNumbers={true} showLast={true} showText={false}/>
                <div className="page-size">
                  <PageSizeSelector options={[15,25,50,100]} listComponent={PageSizeSelect}/>
                </div>
              </div>
            </LayoutResults>

          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
}

ProductsListItem.contextTypes = {
  searchkit: PropTypes.any
};
ProductTypeOption.contextTypes = {
  searchkit: PropTypes.any
};
SystemOption.contextTypes = {
  searchkit: PropTypes.any,
};

SortingArrowSelector.contextTypes = {
  searchkit: PropTypes.any,
};

CustomRefinementListFilter.contextTypes = {
  searchkit: PropTypes.any,
};
ViewSwitcherHitsHeader.contextTypes = {
  searchkit: PropTypes.any,
  ReactTooltip: PropTypes.any,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js